import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ProductApprovalsBulkActionSelectSingleEntityParams {
  limitedOrderingProductRequestId: number;
}
export class ProductApprovalsBulkActionSelectSingleEntity extends BaseEntityClass {
  limited_ordering_product_request_id: number;
  constructor(params: ProductApprovalsBulkActionSelectSingleEntityParams) {
    super();
    this.type = "product_approvals_bulk_actions_select_single";
    this.entity_version = 2;
    this.limited_ordering_product_request_id = params.limitedOrderingProductRequestId;
  }
}
